export default {
  FETCH_SESSIONS: 'SESSIONS/FETCH_SESSIONS',
  SET_SESSIONS: 'SESSIONS/SET_SESSIONS',
  SET_SESSIONS_FAILED: 'SESSIONS/SET_SESSIONS_FAILED',
}
